import React from 'react';
import NavMessage from './NavMessage';
import Logo from '../Logo/Logo';
import Nav from './Nav';
import NavAvatar from './NavAvatar';



const Header = ({ onHeaderClick, orderClosed, showNavMessage, onApprove, onPay, onRevise, user, onLogout, supportServices, setSupportServices, chatWindowVisible, setChatWindowVisible }) => {
  return (
    <header className="header fixed-top" id="header">
    
      <div className="header-content d-flex align-items-center">
        <Logo onHeaderClick={onHeaderClick} />
        
        {/* Only render the Nav component if showNavMessage is false */}
        {!showNavMessage && <Nav onHeaderClick={onHeaderClick} />}
       
        {showNavMessage && (
          <>
            <div className="header-right-content">
                <NavMessage 
                onHeaderClick={onHeaderClick} 
                onRevise={onRevise}
                onApprove={onApprove}
                onPay={onPay}
                orderClosed={orderClosed}
            
                
              />
              <NavAvatar 
               user={user}
               onLogout={onLogout} 
               chatWindowVisible={chatWindowVisible}
               setChatWindowVisible={setChatWindowVisible}
              />
            </div>
          
       </>
          
        )}
           
      </div>
    
    </header>
  );
};

export default Header;
